import { KYMW1400KomaPageModel } from '../kymw1400-koma-page/kymw1400-koma-page.model';
import { PlanSummaryTableModel } from '../vo/plan-summary-table.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 計画値集計表を取得する
 *
 * @export
 * @class GetPlanSummaryTableService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPlanSummaryTableService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1400KomaPageModel = null;
  private vo: PlanSummaryTableModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanSummaryTableService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        PageNum: this.vo.pageNum
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400KomaPageModel} model モデルクラス
   * @param {PlanSummaryTableModel} vo パラメータ
   * @memberof GetPlanSummaryTableService
   */
  execute(model: KYMW1400KomaPageModel, vo: PlanSummaryTableModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14getPlanSummaryTable', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanSummaryTableService
   */
  success(data: any) {
    // 結果データの編集
    if ( data.GPR !== "" || data.SupplyPrice !== "") {    
      //GPRと点単価に小数点以下の値がない場合、「.0」を付ける
      if (!data.GPR.includes('.')) {
        data.GPR = data.GPR + '.0';
      }
      if (!data.SupplyPrice.includes('.')) {
        data.SupplyPrice = data.SupplyPrice + '.0';
      }
    }

    this.model.updatePlanSummaryTable(data);
  }
}
